"use client";

import { useState, useEffect } from "react";
import { TireIndustry } from "@/@types/Tire";
import Link from "next/link";
import { ROUTES } from "@/config/routes";
import Image from "next/image";

type Props = {
  industries: TireIndustry[];
  selectedSlug?: string;
  isMenuOpen: boolean;
  toggleMenu: () => void;
};

export default function TireIndustryCard({
  industries,
  selectedSlug,
  isMenuOpen,
  toggleMenu,
}: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [showMenuIcon, setShowMenuIcon] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowMenuIcon(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMobile && isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [isMobile, isMenuOpen]);

  if (!industries || industries.length === 0) {
    return <p>No Industries available.</p>;
  }

  return (
    <div>
      {!isMobile && (
        <div className="relative block bg-white px-4 pb-4 text-[17px]">
          <p className="pb-2 font-bold text-dark02">Industrias</p>
          <div className="flex flex-col">
            {industries.map((industry, index) => (
              <Link key={index} href={ROUTES.tires.industries(industry.slug)} className="my-[2px]">
                <div className="flex items-center">
                  <input
                  type="checkbox"
                  checked={industry.slug === selectedSlug}
                  className="hidden peer"
                  readOnly
                  />
                  <div className="w-3 h-3 mr-2 border-2 border-gray02 rounded-sm bg-light01 peer-checked:bg-matco"></div>
                  <p className="text-gray03 truncate">
                  {industry.name}
                  </p>
                </div>
              </Link>
            ))}
          </div>
          <Link
            href={ROUTES.tires.root}
            className="flex items-center justify-center gap-2 w-min uppercase mt-4 ml-2 py-2 px-4 text-center bg-grey hover:text-white transition-all"
          >
            <Image
              src="/images/icons/restoreIcon.svg"
              alt="restaurar"
              width={15}
              height={15}
            />
            <span>RESTAURAR</span>
          </Link>
        </div>
      )}

      {isMobile && !isMenuOpen && showMenuIcon && (
        <button
          onClick={toggleMenu}
          className="fixed bottom-5 left-5 bg-yellow-500 text-white p-4 rounded-full shadow-lg z-50"
        >
          <Image
            src="/assets/icons/filter.svg"
            alt="Filtros"
            width={20}
            height={20}
            className="h-5 w-5"
          />
        </button>
      )}

      {isMobile && isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-end z-50"
          onClick={toggleMenu}
        >
          <div
            className="w-full bg-white p-6 rounded-t-2xl shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-end">
              <button
                onClick={toggleMenu}
                className="text-2xl font-bold text-gray-500 hover:text-black"
              >
                ✕
              </button>
            </div>
            <div className="mt-4">
              <p className="py-2 pl-3 text-sm font-bold">Industrias</p>
              <div className="flex flex-col">
                {industries.map((industry, index) => (
                 <Link key={index} href={ROUTES.tires.industries(industry.slug)} className="my-[2px]">
                 <div className="flex items-center">
                   <input
                   type="checkbox"
                   checked={industry.slug === selectedSlug}
                   className="hidden peer"
                   readOnly
                   />
                   <div className="w-3 h-3 mr-2 border-2 border-gray02 rounded-sm bg-light01 peer-checked:bg-matco"></div>
                   <p className="text-gray03 truncate">
                   {industry.name}
                   </p>
                 </div>
               </Link>
                ))}
              </div>
            </div>
            <div className="mt-4">
              <Link
                href={ROUTES.tires.root}
                className="flex items-center justify-center gap-2 w-min uppercase mt-4 ml-2 py-2 px-4 text-center bg-grey hover:text-white transition-all"
              >
                <Image
                  src="/images/icons/restoreIcon.svg"
                  alt="restaurar"
                  width={15}
                  height={15}
                />
                <span>RESTAURAR</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
